import z from 'zod';
import {studyDbSchema} from './studyDbSchema';

/** Output schema for use (with id from document id). */
export const studySchema = studyDbSchema.omit({content: true}).extend({
  id: z.string(),
});

export type Study = z.infer<typeof studySchema>;
